export function createReducer<T> (initialState: T, fnMap: { [key: string]: (state: T, payload: any) => T }) {
  return (state: T = initialState, {type, payload}: { type: string, payload: any }) => {
    const handler = fnMap[type];

    return handler ? handler(state, payload) : state;
  };
}

export function reduceReducers<T> (...reducersArray: ((state: T, action: any) => T)[]) {
  return function (previousState: T, currentAction: any) {
    const reducerFunction = function (accumulator: T, currentReducer: (state: T, action: any) => T) {
      return currentReducer(accumulator, currentAction);
    };

    return reducersArray.reduce(reducerFunction, previousState);
  };
}
